import React, { FunctionComponent } from 'react';

//Mock view to handle page refresh
const MockRouteViewScreen: FunctionComponent = (): JSX.Element => {
    return <React.Fragment />;
};

export default MockRouteViewScreen;
